import * as React from 'react';

import {
  Button,
  DialogContent,
  DialogFooter,
  DialogOverlay,
  DialogTitle,
} from '@rematter/ui-web';
import { LucideX } from 'lucide-react';

import { useTranslations } from '~/modules/settings/i18n/useTranslations';

interface CustomerPortalAddUsersToRoleDialogState {
  isOpen: boolean;
  roleId: string;
  roleName: string;
}

const initialState: CustomerPortalAddUsersToRoleDialogState = {
  isOpen: false,
  roleId: '',
  roleName: '',
};

export const CustomerPortalAddUsersToRoleDialog = () => {
  const t = useTranslations();
  const [state, setState] = React.useState(initialState);
  const [selectedUserIds, setSelectedUserIds] = React.useState<Set<string>>(
    new Set(),
  );

  const closeDialog = () => {
    setState(initialState);
    setSelectedUserIds(new Set());
  };

  return (
    <DialogOverlay
      isOpen={state.isOpen}
      onOpenChange={(open) => {
        if (!open) closeDialog();
      }}
      className="@CustomerPortalAddUsersToRoleDialog"
    >
      <DialogContent className="min-w-[500px]" closeButton={false}>
        <div className="flex items-center justify-between px-4 pt-4">
          <DialogTitle className="text-xl font-bold">
            {t.customerPortal.roles.addUsersDialog.title.replace(
              '{roleName}',
              state.roleName,
            )}
          </DialogTitle>
          <button
            onClick={closeDialog}
            className="flex items-center justify-center rounded bg-neutral/5 p-[3px]"
            aria-label="Close"
          >
            <LucideX className="size-6 text-neutral/60" />
          </button>
        </div>

        <div className="flex flex-1 flex-col gap-5 overflow-hidden px-6 py-5">
          <span className="text-sm text-neutral/50">
            {t.customerPortal.roles.addUsersDialog.description}
          </span>
        </div>

        <DialogFooter>
          <Button variant="outline" color="neutral" onPress={closeDialog}>
            {t.customerPortal.actions.discard}
          </Button>
          <Button
            variant="solid"
            color="primary"
            onPress={closeDialog}
            isDisabled={selectedUserIds.size === 0}
          >
            {t.customerPortal.roles.addUsersDialog.actions.save}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogOverlay>
  );
};
